import React, { useEffect, useState } from 'react';
import SectionTryhard from './SectionTryhard';
import { motion, useMotionValue } from 'motion/react';
import SectionPips from './SectionPips';
import SectionEdge from './SectionEdge';
import { animate } from 'motion/react';
import { Link } from 'react-router-dom';
import { SiteTransitions } from '../../../utils/transitions';

const Landing: React.FC = () => {
    const baseHeight = `${((1 / 3) * 100).toString()}%`;
    const contractedHeight = '25%';
    const expandedHeight = '50%';

    const tryhardHeight = useMotionValue(baseHeight);
    const pipsHeight = useMotionValue(baseHeight);
    const edgeHeight = useMotionValue(baseHeight);

    const [tryhardHovered, setTryhardHovered] = useState<boolean>(false);
    const [pipsHovered, setPipsHovered] = useState<boolean>(false);
    const [edgeHovered, setEdgeHovered] = useState<boolean>(false);

    const tryhardHoveredCB = () => {
        setTryhardHovered(true);
        setPipsHovered(false);
        setEdgeHovered(false);
        animate(tryhardHeight, expandedHeight);
        animate(pipsHeight, contractedHeight);
        animate(edgeHeight, contractedHeight);
    }
    const pipsHoveredCB = () => {
        setTryhardHovered(false);
        setPipsHovered(true);
        setEdgeHovered(false);
        animate(tryhardHeight, contractedHeight);
        animate(pipsHeight, expandedHeight);
        animate(edgeHeight, contractedHeight);
    }
    const edgeHoveredCB = () => {
        setTryhardHovered(false);
        setPipsHovered(false);
        setEdgeHovered(true);
        animate(tryhardHeight, contractedHeight);
        animate(pipsHeight, contractedHeight);
        animate(edgeHeight, expandedHeight);
    }

    useEffect(() => {
        if (!tryhardHovered && !pipsHovered && !edgeHovered) {
            tryhardHeight.set(baseHeight);
            pipsHeight.set(baseHeight);
            edgeHeight.set(baseHeight);
        }
    }, [tryhardHovered, pipsHovered, edgeHovered])

    return (
        <motion.div
            key={'overlay'}
            className='size-full absolute z-10'
            variants={SiteTransitions}
            initial='initial'
            animate='animate'
            exit='exit'
        >
            <div
                className='size-full overflow-hidden relative'
            >
                <Link to='/tryhard'>
                    <SectionTryhard height={tryhardHeight} hoverCB={tryhardHoveredCB} leaveCB={() => setTryhardHovered(false)} />
                </Link>

                <Link to='/pips'>
                    <SectionPips height={pipsHeight} hoverCB={pipsHoveredCB} leaveCB={() => setPipsHovered(false)} />
                </Link>

                <Link to='edge'>
                    <SectionEdge height={edgeHeight} hoverCB={edgeHoveredCB} leaveCB={() => setEdgeHovered(false)} />
                </Link>
            </div>
        </motion.div>
    )
}

export default Landing;